const pad = (value: number): string => String(value).padStart(2, "0");

export const wallClockToDatetimeLocal = (wallClock: string): string => {
  const normalized = wallClock.trim().replace(" ", "T");

  return normalized.slice(0, 16);
};

export const addMinutesToDatetimeLocal = (value: string, minutes: number): string => {
  const [date, time] = value.split("T");

  if (!date || !time) {
    return value;
  }

  const [hours, mins] = time.split(":").map(Number);
  const total = Math.min(Math.max(hours * 60 + mins + minutes, 0), 23 * 60 + 59);

  return `${date}T${pad(Math.floor(total / 60))}:${pad(total % 60)}`;
};

export const defaultAbsenceRange = (
  date: string
): { startLocal: string; endLocal: string } => ({
  startLocal: `${date}T12:00`,
  endLocal: `${date}T13:00`,
});
